import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE, setCsrfToken } from "../services/server";
import { fetchMe } from "../services/auth";
import { useAuth } from "../services/AuthContext";
import { brokerPortalUrl } from "../services/hostRouting";

// Login for ai.qada.io. Hits the SAME /users/auth/login/ endpoint as
// the broker app — no parallel auth logic, no second user database.
// A user who logs in here has a session cookie scoped to .qada.io
// (SESSION_COOKIE_DOMAIN) so they're also authenticated against
// api.qada.io / app.qada.io if they navigate there.
export default function AILogin() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);

    try {
      const csrfRes = await fetch(`${API_BASE}/users/auth/csrf/`, {
        credentials: "include",
      });
      const csrfData = await csrfRes.json().catch(() => ({}));
      const csrftoken = csrfData.csrftoken;
      if (csrftoken) setCsrfToken(csrftoken);

      const res = await fetch(`${API_BASE}/users/auth/login/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrftoken || "",
        },
        body: JSON.stringify({ username: email, password }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || `Inloggning misslyckades (${res.status})`);
        setBusy(false);
        return;
      }

      let me = null;
      try {
        me = await fetchMe();
        setUser(me);
      } catch {
        // non-fatal — AIHome will re-fetch context on mount
      }

      // Step 17 — a non-AI user who authenticates on ai.<host> must
      // be sent back to the normal application. RequireAI would also
      // catch this later, but redirecting here avoids a flash of the
      // AI shell in between login and guard evaluation.
      if (me && !me?.global_nav?.is_ai) {
        const url = brokerPortalUrl("/projects");
        if (url) {
          window.location.href = url;
          return;
        }
      }

      navigate("/");
    } catch (err) {
      setError(err.message || "Något gick fel");
      setBusy(false);
    }
  }

  return (
    <div className="qai-login-wrap">
      <form className="qai-login-card" onSubmit={handleSubmit}>
        <h1>Qada AI</h1>
        <p>Logga in för att fortsätta</p>

        <label className="qai-login-field">
          Email
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="qai-login-field">
          Lösenord
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {error && (
          <div className="qai-error" style={{ marginTop: 4 }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          className="qai-send"
          disabled={busy || !email || !password}
        >
          {busy ? "Loggar in…" : "Logga in"}
        </button>
      </form>
    </div>
  );
}
